import { Chip, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
  styleFitContainer,
} from "react-compare-slider";

import { CheckerboardBackground } from "@/components/ui-v2/Backgrounds/Checkerboard";

import { useTheme } from "../../components/ui-v2";
interface GalleryImagePreviewSliderProps {
  imageUrl: string;
  imageSrcSet: string;
  beforeUrl: string;
  aspectRatio: string;
}

export const GalleryImagePreviewSlider = (
  props: GalleryImagePreviewSliderProps,
) => {
  const { imageUrl, imageSrcSet, beforeUrl, aspectRatio } = props;

  const theme = useTheme();
  const [position, setPosition] = useState(100);

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setPosition(0);
    }, 250);

    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <>
      <Stack
        spacing={0}
        direction="row"
        sx={{
          position: "absolute",
          inset: 0,
          margin: "auto",
          aspectRatio,
          maxWidth: "100%",
          maxHeight: "100%",
          justifyContent: "center",
        }}
      >
        <ReactCompareSlider
          style={{
            width: "fit-content",
            height: "100%",
          }}
          position={position}
          transition="0.3s ease-in-out"
          onPositionChange={setPosition}
          keyboardIncrement={0}
          itemOne={
            <CheckerboardBackground
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: theme.palette.secondary[7],
                justifyContent: "center",
              }}
            >
              <ReactCompareSliderImage
                src={beforeUrl}
                style={styleFitContainer({
                  objectFit: "contain",
                  width: "auto",
                  height: "auto",
                  maxHeight: "100%",
                })}
              />
            </CheckerboardBackground>
          }
          itemTwo={
            <CheckerboardBackground
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: theme.palette.secondary[7],
              }}
            >
              <ReactCompareSliderImage
                style={styleFitContainer({
                  objectFit: "contain",
                  width: "auto",
                  height: "100%",
                  margin: "auto",
                })}
                src={imageUrl}
                srcSet={imageSrcSet}
                sizes="100vw"
              />
            </CheckerboardBackground>
          }
        />
      </Stack>
      {position > 0 && (
        <Chip
          variant="outlined"
          color="secondary"
          size="medium"
          label="BEFORE"
          sx={{
            position: "absolute",
            bottom: 4,
            left: 4,
            zIndex: 10,
          }}
        />
      )}
      {position > 0 && position < 100 && (
        <Chip
          variant="outlined"
          color="secondary"
          size="medium"
          label="AFTER"
          sx={{
            position: "absolute",
            bottom: 4,
            right: 4,
            zIndex: 10,
          }}
        />
      )}
    </>
  );
};
